(() => {
  if (customElements.get('akaari-whatsapp-stylist')) return;

  class AkaariWhatsAppStylist extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.button = this.querySelector('.akaari-stylist__button');
      if (!this.button) return;

      this.onClick = this.onClick.bind(this);
      this.onVariantUpdate = this.onVariantUpdate.bind(this);

      this.button.addEventListener('click', this.onClick);
      document.addEventListener('variant:update', this.onVariantUpdate);
      this.refreshHref();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      document.removeEventListener('variant:update', this.onVariantUpdate);
    }

    onVariantUpdate(event) {
      const productId = String(event?.detail?.data?.productId || '');
      const currentProductId = String(this.dataset.productId || '');
      if (productId && currentProductId && productId !== currentProductId) return;

      const fresh = event?.detail?.data?.html?.querySelector('akaari-whatsapp-stylist');
      if (fresh) {
        this.dataset.productId = fresh.dataset.productId || this.dataset.productId || '';
        this.dataset.productTitle = fresh.dataset.productTitle || this.dataset.productTitle || '';
      }

      window.requestAnimationFrame(() => this.refreshHref());
    }

    onClick() {
      this.refreshHref();
    }

    getScope() {
      return this.closest('[data-testid="product-information-details"]') ||
        this.closest('.product-information') ||
        document;
    }

    getSelectedOptions() {
      const picker = this.getScope().querySelector('variant-picker');
      if (!picker) return [];

      const lines = [];
      const seen = new Set();

      picker.querySelectorAll('.variant-option').forEach((option) => {
        let label = '';
        let value = '';

        const select = option.querySelector('select');
        const fieldset = option.matches('fieldset') ? option : option.querySelector('fieldset');

        if (select) {
          const labelEl = option.querySelector('label');
          label = labelEl?.textContent?.trim() || select.name?.replace(/^options\[|\]$/g, '') || '';
          value = select.selectedOptions?.[0]?.textContent?.replace(/\s+-\s+Unavailable\s*$/i, '')?.trim() || select.value || '';
        } else if (fieldset) {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          const legend = fieldset.querySelector('legend');
          if (legend) {
            const clone = legend.cloneNode(true);
            clone.querySelectorAll('.variant-option__swatch-value').forEach((node) => node.remove());
            label = clone.textContent?.trim() || '';
          }
          value = checked?.value?.trim() || '';
        } else {
          const singleValue = option.querySelector('[data-testid="variant-option-single-value"]');
          const clone = option.cloneNode(true);
          clone.querySelectorAll('[data-testid="variant-option-single-value"]').forEach((node) => node.remove());
          label = clone.textContent?.trim() || '';
          value = singleValue?.textContent?.trim() || '';
        }

        const key = `${label}:${value}`;
        if (label && value && !seen.has(key)) {
          seen.add(key);
          lines.push(`${label}: ${value}`);
        }
      });

      return lines;
    }

    getCurrentPrice() {
      const priceEl = this.getScope().querySelector('product-price');
      if (!priceEl) return '';

      const text = priceEl.textContent
        .replace(/\s+/g, ' ')
        .trim();

      return text;
    }

    getVariantId() {
      const picker = this.getScope().querySelector('variant-picker');
      const json = picker?.querySelector('script[type="application/json"]')?.textContent;
      if (!json) return '';

      try {
        return String(JSON.parse(json)?.id || '');
      } catch (_) {
        return '';
      }
    }

    getProductUrl() {
      const url = new URL(window.location.href);
      const variantId = this.getVariantId();
      if (variantId) url.searchParams.set('variant', variantId);
      return url.toString();
    }

    buildMessage() {
      const lines = [];
      const intro = (this.dataset.intro || '').trim();
      const productTitle = (this.dataset.productTitle || document.title || '').trim();

      if (intro) lines.push(intro);
      if (productTitle) lines.push(`Product: ${productTitle}`);

      if (this.dataset.includeVariant === 'true') {
        const options = this.getSelectedOptions();
        if (options.length) lines.push(...options);
      }

      if (this.dataset.includePrice === 'true') {
        const price = this.getCurrentPrice();
        if (price) lines.push(`Price: ${price}`);
      }

      if (this.dataset.includeUrl === 'true') {
        lines.push(`Link: ${this.getProductUrl()}`);
      }

      return lines.join('\n');
    }

    refreshHref() {
      if (!this.button) return;
      const phone = String(this.dataset.phone || '').replace(/[^0-9]/g, '');
      if (!phone) return;

      const message = this.buildMessage();
      this.button.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    }
  }

  customElements.define('akaari-whatsapp-stylist', AkaariWhatsAppStylist);
})();
